import HoverState from '@engoo/react-hover-state';
import { GREY_B, GREY_T } from 'app/constants/Colors';
import { buttonReset } from 'app/constants/Styles';
import { useClasses } from 'app/utils/css';
import { FunctionComponent, ReactElement } from 'react';
import { connectRenderProp } from 'app/utils/connect';

interface IProps {
  children: (className: string) => ReactElement;
  isHovered: boolean;
  size?: string;
}

const ICON_SIZE = '30px';
const SocialIconButtonA: FunctionComponent<IProps> = ({
  children,
  isHovered,
  size = ICON_SIZE,
}) => {
  const css = useClasses({
    socialIconButtonA: {
      ...buttonReset,
      display: 'flex',
      fill: isHovered ? GREY_T : GREY_B,
      width: size,
      height: size,
    },
  });
  return (
    children(css.socialIconButtonA)
  );
};


export default connectRenderProp('isHovered', HoverState)(SocialIconButtonA);
